// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosizeTextareaController from "./autosize_textarea_controller"
application.register("autosize-textarea", AutosizeTextareaController)

import AudioPlayerController from "./audio_player_controller"
application.register("audio-player", AudioPlayerController)

import CastEditController from "./cast_edit_controller"
application.register("cast-edit", CastEditController)

import CheckboxListController from "./checkbox_list_controller"
application.register("checkbox-list", CheckboxListController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DeliverablesUploadController from "./deliverables_upload_controller"
application.register("deliverables-upload", DeliverablesUploadController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DynamicStickyController from "./dynamic_sticky_controller"
application.register("dynamic-sticky", DynamicStickyController)

import EditTranscriptsController from "./edit_transcripts_controller"
application.register("edit-transcripts", EditTranscriptsController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FoldableController from "./foldable_controller"
application.register("foldable", FoldableController)

import FoldableGroupController from "./foldable_group_controller"
application.register("foldable-group", FoldableGroupController)

import FormSubmitBtnSpinnerController from "./form_submit_btn_spinner_controller"
application.register("form-submit-btn-spinner", FormSubmitBtnSpinnerController)

import HighlightTranscriptController from "./highlight_transcript_controller"
application.register("highlight-transcript", HighlightTranscriptController)

import LazyTagSelectController from "./lazy_tag_select_controller"
application.register("lazy-tag-select", LazyTagSelectController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ReporterSelectorController from "./reporter_selector_controller"
application.register("reporter-selector", ReporterSelectorController)

import SearchSelectController from "./search_select_controller"
application.register("search-select", SearchSelectController)

import SortController from "./sort_controller"
application.register("sort", SortController)

import TagSelectController from "./tag_select_controller"
application.register("tag-select", TagSelectController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import UppyUploadController from "./uppy_upload_controller"
application.register("uppy-upload", UppyUploadController)

import VideoActionCableController from "./video_action_cable_controller"
application.register("video-action-cable", VideoActionCableController)

import VideoBlockLoadController from "./video_block_load_controller"
application.register("video-block-load", VideoBlockLoadController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import VideoTimecodesController from "./video_timecodes_controller"
application.register("video-timecodes", VideoTimecodesController)

import VideoUploadModeController from "./video_upload_mode_controller"
application.register("video-upload-mode", VideoUploadModeController)

import VirtualFormController from "./virtual_form_controller"
application.register("virtual-form", VirtualFormController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import SidePanelController from "./side_panel_controller"
application.register("side-panel", SidePanelController)

import SceneRequestController from "./scene_request_controller"
application.register("scene-request", SceneRequestController)

import SceneSorterController from "./scene_sorter_controller"
application.register("scene-sorter", SceneSorterController)

import SceneUpdateController from "./scene_update_controller"
application.register("scene-update", SceneUpdateController)
